var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { axiosPrivate } from "../../api/axios";
import { updateOrderDeliveryPickupLocation_V2, updateOrderDeliveryPickupLocationWithCharge_V2, } from "./UpcomingOrdersRequests";
// ! @master-to-company-wizard
// ! newAddressData.orderModel = order;
export const updateFunction_V2 = (_key, { arg: { newAddressData, giftCardId, balance } }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = balance && (balance === null || balance === void 0 ? void 0 : balance.remainingBalance) > 0
        ? yield updateOrderDeliveryPickupLocationWithCharge_V2(Object.assign(Object.assign({}, newAddressData), { giftCardId }))
        : yield updateOrderDeliveryPickupLocation_V2(newAddressData);
    return response.data;
});
export const getOrdersByDate = (startDate, endDate, fetchAllOrders, pageIndex, pageSize, onSuccess, onError) => {
    return axiosPrivate
        .get(`/Account/GetOrders?from=${moment(startDate).format("L")}
      &to=${moment(endDate).format("L")}
      &fetchAllOrders=${fetchAllOrders}
      &pageIndex=${pageIndex}
      &pageSize=${pageSize}`)
        .then(onSuccess)
        .catch(onError);
};
